const getters = {
  userInfo: state => state.user.userInfo,
  systemInfo: state => state.system.systemInfo,
  regionInfo: state => state.district.regionInfo,
}
export default getters
